import transFunctions from "@/support/transitions/mixins/transFunctions.js";
import transOptions from "@/support/transitions/mixins/transOptions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import moment from "moment";

export default {
  // eslint-disable-next-line
  mixins: [
    transFunctions,
    transOptions,
    numberFunctions
  ],
  data() {
    return {
      tempAction: null
    };
  },
  methods: {
    generateWorkCallTransitions(status, type) {
      // INITIAL
      let trans = this.formTransitions;
      trans.model = type;
      trans.flow = [];
      trans.hist = [];
      let level = 1;
      let title = null;
      let icon = null;
      let tempFlow = null;
      let obj = null;
      let com = "Maint Call generated.";
      let tempTransFlow = [];

      // DEFINE Level
      if (status !== null && status !== undefined) {
        if (status === "Created") {
          level = 1;
        }
        if (status === "Scope") {
          level = 2;
        }
        if (status === "Resource") {
          level = 3;
        }
        if (status === "Plan") {
          level = 4;
        }
        if (status === "Decide") {
          level = 5;
        }
        if (status === "Preparation") {
          level = 6;
        }
        if (status === "Execute") {
          level = 6;
        }
      }
      // DEFINE TRANS
      if (level > 0) {
        // Generate TRANS
        for (var i = 0; i < level; i++) {
          trans.level = i + 1;
          trans.stat.revert = false;
          trans.stat.lock = false;
          trans.stat.progress = true; // completed
          trans.stat.defer = false;
          trans.ntrans = trans.ntrans + 1; // number of transitions
          title = this.defineFlowItem(trans.model, trans.level - 1).title;
          icon = this.defineFlowItem(trans.model, trans.level - 1).icon;
          tempFlow = this.generateFlow(true, com, title, icon);
          obj = Object.assign({}, tempFlow);
          // change date to prevent duplicate
          // eslint-disable-next-line
          obj.date = moment().subtract(level - i, "days").format();
          tempTransFlow.push(obj);
        }
        trans.flow = tempTransFlow;
        trans.hist = tempTransFlow;
      }
      // RETURN trans
      return trans;
    }
  }
};
